<template>
  <div style="display: flex; justify-content: center">
    <el-popconfirm
      v-if="data.type !== 'self' && data.status !== 'evaluated' && (this.data.status === 'manage_request' || evaluation.status === 'started')"
      confirm-button-text='Да'
      cancel-button-text='нет'
      icon="el-icon-question"
      :title="'Вы уверены, что хотите отправить уведомление и напомнить ' + (this.data.status === 'manage_request' ? 'руководителю об согласовании?' : 'пользователю об оценке?')"
      @confirm="evalRemind(data.evaluation_id, data.evaluatee_id, data.evaluator_id)"
    >
      <el-button
        slot="reference"
        class="table-action-button"
        size="mini"
        round
        icon="far fa-bell"
      >
      </el-button>
    </el-popconfirm>
  </div>
</template>

<script>
export default {
  name: "eval-remind-button",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    evaluation: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    evalRemind(evaluation_id, evaluatee_id, evaluator_id) {
      this.$api.evaluation.evalRemind({
        evaluation_id: evaluation_id,
        evaluatee_id: evaluatee_id,
        evaluator_id: evaluator_id,
        chief: this.data.status === 'manage_request'
      })
        .finally(() => {
          this.$notify.success({
            title: 'Успех',
            message: 'Напоминание успешно отправлено'
          });
        })
    },
  }
}
</script>

<style scoped>

</style>